import React from 'react';
import PropTypes from 'prop-types';

const StepProjectSelect = ({ projects, searchProject, setSearchProject, onSelectProject }) => {
  const filteredProjects = projects.filter(p =>
    p.project_name.toLowerCase().includes(searchProject.toLowerCase())
  );

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <h3 className="text-lg font-semibold text-text-primary">Select a Project</h3>
        <p className="text-sm text-text-secondary">Choose which project you want to run</p>
      </div>
      
      <input
        type="text"
        className="w-full px-4 py-2.5 text-sm text-text-primary bg-bg-elevated border border-primary-700/50 rounded-lg focus:outline-none focus:border-primary-500 focus:ring-2 focus:ring-primary-500/20 transition-all duration-fast placeholder:text-text-tertiary shadow-inner"
        placeholder="Search projects..."
        value={searchProject}
        onChange={(e) => setSearchProject(e.target.value)}
      />

      {filteredProjects.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-12 px-6 text-center bg-bg-tertiary border border-border-primary rounded-lg">
          <p className="text-sm text-text-secondary">{searchProject ? 'No prompts match your search' : 'No completed prompts available'}</p>
        </div>
      ) : (
        <div className="space-y-2 max-h-[400px] overflow-y-auto pr-2 [&::-webkit-scrollbar]:w-2 [&::-webkit-scrollbar-track]:bg-transparent [&::-webkit-scrollbar-thumb]:bg-border-primary [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-thumb:hover]:bg-text-tertiary">
          {filteredProjects.map((proj) => (
            <div
              key={proj.id}
              className={`relative p-3 bg-bg-secondary border-2 rounded-lg cursor-pointer transition-all duration-fast hover:border-primary-500 hover:z-10 hover:shadow-lg border-border-primary`}
              onClick={() => onSelectProject(proj)}
            >
              <div className="flex items-center justify-between gap-3">
                <span className="text-sm font-semibold text-text-primary truncate">{proj.project_name || 'Untitled'}</span>
                <div className="flex items-center gap-1.5 flex-shrink-0">
                  <span className="text-[10px] px-1.5 py-0.5 rounded font-mono bg-bg-tertiary text-text-secondary border border-border-primary">
                    {proj.user_input?.type || 'N/A'}
                  </span>
                  <span className="text-[10px] px-1.5 py-0.5 rounded font-mono bg-primary-600 text-white">
                    {proj.user_input?.output_type || 'Text'}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

StepProjectSelect.propTypes = {
  projects: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    project_name: PropTypes.string,
    user_input: PropTypes.object
  })).isRequired,
  searchProject: PropTypes.string.isRequired,
  setSearchProject: PropTypes.func.isRequired,
  onSelectProject: PropTypes.func.isRequired
};

export default StepProjectSelect;

